import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageUserActivity
 * @description
 * # manageUserActivity
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'manageUserActivity',
    ($location, $ngRedux, $scope, $rootScope, $route, $http, ENV, $timeout) => {
      if (!$scope.isAdminUser) {
        $location.path('/');
      }
      $rootScope.userId = null;

      $scope.processParams = () =>
        new Promise((resolve) => {
          const { activityId, petId, redemptionId, transactionId, mediaId } = $route.current.params;
          if (activityId === 'apply-user-activity') {
            $rootScope.openComponent({ component: 'apply-activity' });
          }
          if (petId) {
            $scope.onSelectPet({
              petId: petId,
              beforeRoute: `${$rootScope.routes['user-activity']}/pet-detail/${petId}`,
            });
          }
          if (redemptionId) {
            const beforeRoute = `${$rootScope.routes['user-activity']}/redemption-detail/${transactionId}`;
            const closeRoute = $rootScope.routes['user-activity'];
            $scope.showRedemptionDetail({
              redemptionId: redemptionId,
              beforeRoute: beforeRoute,
              closeRoute: closeRoute,
            });
          }
          if (transactionId) {
            const beforeRoute = `${$rootScope.routes['user-activity']}/transaction-detail/${transactionId}`;
            const closeRoute = $rootScope.routes['user-activity'];
            $scope.showTransactionDetail({
              transactionId: transactionId,
              beforeRoute: beforeRoute,
              closeRoute: closeRoute,
            });
          }
          if (mediaId) {
            $location.path(
              `/admin/loyalty/activities/manage-user-activities/media/${mediaId}`,
              false,
            );
            $scope.showMediaDetail({
              media: { id: mediaId },
            });
          }
          resolve(true);
        });

      $scope.reviewMedia = ({ media, userId }) => {
        $location.path(
          `/admin/loyalty/activities/manage-user-activities/media/${media[0].id}`,
          false,
        );
        $scope.showMediaDetail({ media: media, userId: userId });
      };

      $scope.generateActivityPetDetailLink = (petId) => {
        return `${$rootScope.routes['user-activity']}/pet-detail/${petId}`;
      };

      $scope.generatebeforeRoute = (type, id) => {
        return `${$rootScope.routes['user-activity']}/${type}/${id}`;
      };

      $scope.generatecloseRoute = () => {
        return `${$rootScope.routes['user-activity']}`;
      };

      $scope.reissuePointsRequest = (record) => {
        const data = {
          'user-activities': {
            reissue_points: true,
          },
        };
        $scope
          .reissueExpiredPoints($http, ENV, record.id, data)
          .then((response) => {
            $rootScope.showErrorModal = true;
            $rootScope.errorModalOptions = {
              heading: 'SUCCESS',
              message: `${response.num_points} points have been reissued.`,
              buttons: [
                {
                  label: 'OK',
                  href: '#',
                  clickFn: () => {
                    $rootScope.showErrorModal = false;
                  },
                },
              ],
            };
            $rootScope.getData();
          })
          .catch((error) => {
            const errors = error.data['user-activities'];
            $rootScope.errorModalOptions = {
              heading: 'ERROR',
              message: errors,
              buttons: [
                {
                  label: 'OK',
                  href: '#',
                  clickFn: () => {
                    $rootScope.showErrorModal = false;
                  },
                },
              ],
            };
            $timeout(() => {
              $rootScope.showErrorModal = true;
            }, 100);
          });
      };

      $scope.showReissuePointsConfirmModal = (record) => {
        var expireDate = new Date();
        expireDate.setMonth(expireDate.getMonth() + 15);
        const expiration = expireDate.toLocaleDateString();
        const amount = Number(record.num_points) < 0 ? record.num_points * -1 : record.num_points;
        $rootScope.showErrorModal = true;
        $rootScope.errorModalOptions = {
          heading: 'WARNING!',
          message: `Are you sure you want to re-issue ${amount} points to this user? These points will expire on ${expiration}`,
          buttons: [
            {
              label: 'OK',
              href: '#',
              clickFn: () => {
                $rootScope.showErrorModal = false;
                $scope.reissuePointsRequest(record);
              },
            },
            {
              label: 'Cancel',
              href: '#',
              clickFn: () => {
                $rootScope.showErrorModal = false;
              },
            },
          ],
        };
      };

      $scope.init = () => {
        $rootScope.previousRoute = $rootScope.routes['user-activity'];
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
        $scope.processParams();
      };

      $scope.table = {
        name: 'Manage User Activities',
        options: {
          endpoint: '/2.0/user-activities/',
          endpoint_data_key: 'user-activities',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'activity',
          scale_up: true,
          search_key: 'User Activities',
          id_prefix: 'useractivities',
          search_required: true,
        },
        actions: [
          {
            name: 'Apply User Activity',
            link: '#',
            onclick: () => {
              const beforeRoute = `${$rootScope.routes['user-activity']}/apply-user-activity`;
              const closeRoute = $rootScope.routes['user-activity'];
              $scope.openComponent({
                component: 'apply-activity',
                closeRoute: closeRoute,
                beforeRoute: beforeRoute,
              });
            },
            order: 0,
            superuser: false,
          },
        ],
        columns: [
          {
            name: 'Activity Date',
            options: {
              content: '{{ record.activity_date }}',
              class: '',
            },
          },
          {
            name: "User's Name",
            options: {
              content:
                '<a ng-if="record.user.first_name || record.user.last_name" href="#" ng-href="/admin/users/manage-users/{{ record.user.id }}">' +
                '{{ record.user.first_name }} {{ record.user.last_name }}' +
                '</a>' +
                '<br ng-if="record.user.contact_information.email && (record.user.first_name || record.user.last_name)" />' +
                '<a ng-class="{\'small email\': (record.user.first_name || record.user.last_name)}" ng-if="record.user.contact_information.email" href="#" ng-href="/admin/users/manage-users/{{ record.user.id }}">' +
                '{{ record.user.contact_information.email }}' +
                '</a>',
              class: 'td-user',
            },
          },
          {
            name: 'Data Type',
            options: {
              content:
                '{{ ["Media", "Promotion Code", "Redemption", "Transaction", "Journey"].includes(record.activity_type) ? record.activity_type : (record.activity_type.toLowerCase() !== record.activity_name.toLowerCase() && (record.activity_name && record.activity_type) ? record.activity_name + " - " + record.activity_type : record.activity_type) }}',
              class: 'capitalize',
            },
          },
          {
            name: 'Activity Points',
            options: {
              content:
                '{{ record.num_points || 0 }}' +
                '<span ng-if="record.redemption && record.redemption.status.id < -2" class="bold italic pending">(pending)</span>' +
                '<span ng-if="record.transaction && record.transaction.status.id == 1" class="bold italic pending">(pending)</span>',
              class: '',
            },
          },
          {
            name: 'Additional Details',
            options: {
              content:
                '<div ng-if="record.media && record.media.length" class="media-additional-detail"><div class="media-id"><span class="bold italic">Media Count:</span> {{ record.media.length }}</div>' +
                '<div class="pet-info" ng-if="record.media.pets"><div class="italic">for</div><div ng-repeat="pet in record.media.pets"><a ng-click="onSelectPet({petId: pet.id, beforeRoute: generateActivityPetDetailLink(pet.id)})" href="#">{{ pet.name }}</a></div>' +
                '</div></div>' +
                '<div ng-if="record.redemption"><span class="bold italic">Redemption ID:</span> {{record.redemption.id }}</div>' +
                '<div ng-if="record.transaction"><span class="bold italic">Transaction ID:</span> {{ record.transaction.id }}' +
                '<span class="bold italic" ng-if="record.transaction.status == 1">(submitted)</span></div>' +
                '<div ng-if="!record.transaction && !record.redemption && !record.media"><span class="bold italic">Activity ID:</span> {{ record.id }}</div>' +
                '<div ng-if="!record.transaction && !record.redemption && !record.media && record.user_activity_id"><span class="bold italic">User Activity ID:</span> {{ record.user_activity_id }}</div>',
              class: '',
            },
          },
          {
            name: 'Notes/Action',
            options: {
              content:
                '<div ng-if="record.media" class="detail-content"><div><a href="#" ng-click="reviewMedia({media: record.media, userId: record.user.id})">View Media Details</a></div></div>' +
                '<div ng-if="record.activity_type.includes(\'Promotion Code\')" >{{ record.activity_name }}<br />{{ record.activity_description }}</div>' +
                '<div ng-if="record.activity_type.includes(\'Redemption\')" ><a href="#" ng-click="showRedemptionDetail({redemptionId: record.redemption_id, beforeRoute: generatebeforeRoute(\'redemption-detail\', record.redemption_id), closeRoute: generatecloseRoute()})">View Redemption Details</a></div>' +
                '<div ng-if="record.activity_type.includes(\'Transaction\')" ><a href="#" ng-click="showTransactionDetail({transactionId: record.transaction_id, beforeRoute: generatebeforeRoute(\'transaction-detail\', record.transaction_id), closeRoute: generatecloseRoute()})">View Transaction Details</a></div>' +
                '<div ng-if="record.activity_name === \'expired points\'" class="default-note"><a href="#" ng-click="showReissuePointsConfirmModal(record)">Reissue Points</a></div>' +
                '<div ng-if="!record.media_id && !record.redemption_id && !record.transaction_id && record.notes" class="default-note">{{ record.notes }}</div>',
              class: '',
            },
          },
        ],
        filters: [
          /* {
          name: 'User',
          type: 'angucomplete',
          options: {
            class: 'user-filter above-divider',
            query_string_parameter: 'user_id',
            remove_all: true,
            remove_all_key: 'users',
            search_endpoint: '/2.0/users/?groups=2',
            search_endpoint_data_key: 'data',
            selected: [],
            selected_key: ['first_name', 'last_name'],
            selected_remove_key: 'id',
          },
          angucomplete_parameters: {
            id: 'user-name',
            placeholder: 'User Name',
            pause: 1000,
            datafield: 'users',
            isclearafterselect: true,
            selectedobject: 'nameEmail',
            searchfields: 'first_name,last_name,email',
            titlefield: 'first_name,last_name',
            descriptionfield: ['contact_information', 'email'],
            minlength: 2,
            inputclass: 'form-control form-control-small',
            matchclass: 'highlight',
            searchfn: $scope.filterUsers,
            nextfn: $scope.filterUsersPage,
            onselect: $scope.setSelectedUsers,
            preselected: [],
            isUser: true,
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        }, */
          {
            name: 'Activity Completion',
            type: 'multiple_choice',
            options: {
              choices: {
                'Completed Records': { state: true, value: 'completed', order: 0 },
                'Incomplete Records': { state: true, value: 'incomplete', order: 1 },
              },
              class: 'above-divider',
              query_string_parameter: 'activity_completion',
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Activity Data Types',
            type: 'multiple_choice',
            options: {
              choices: {
                Media: { state: true, value: 'media', order: 0 },
                'Promotion Codes': { state: true, value: 'promotion_codes', order: 1 },
                Transactions: { state: true, value: 'transactions', order: 2 },
                Redemptions: { state: true, value: 'redemptions', order: 3 },
                Journeys: { state: true, value: 'journey', order: 4 },
                'Member Tiers': { state: true, value: 'member_tier', order: 5 },
                'Other Point-Based Activities': {
                  state: true,
                  value: 'other_point_based_activities',
                  order: 6,
                },
                'Authorized Users': { state: true, value: 'authorized_user', order: 7 },
                'Inbox Messages': { state: true, value: 'inbox_message', order: 8 },
                Other: { state: true, value: 'other', order: 9 },
              },
              class: '',
              query_string_parameter: 'data_type',
              select_all: true,
            },
          },
          {
            name: 'Activity Types',
            type: 'multiple_choice',
            options: {
              choices: {},
              choices_endpoint: '/2.0/activity-types/?paginate=false&order=title',
              choices_endpoint_data_key: 'activity-types',
              class: 'scroll-choices above-divider',
              name_attribute: 'title',
              no_selected_parameter: 'none',
              query_string_parameter: 'activity_type',
              select_all: true,
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Point Adjustments',
            type: 'single_choice',
            options: {
              choices: {
                All: { type: 'standard', state: true, value: 'all', order: 0 },
                'Only Adjustments': {
                  type: 'standard',
                  state: false,
                  value: 'adjustments',
                  order: 1,
                },
                'Only Credits': { type: 'standard', state: false, value: 'credits', order: 2 },
                'Only Debits': { type: 'standard', state: false, value: 'debits', order: 3 },
                'Custom Amount': {
                  type: 'amount',
                  state: false,
                  value: 'amount',
                  amount: '',
                  date_field: false,
                  order: 4,
                  error: false,
                },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: false,
                  order: 5,
                  error: false,
                },
              },
              class: 'point-adjustments-filter',
              query_string_parameter: 'point_adjustment',
            },
          },
          {
            name: 'Timeframe',
            type: 'single_choice',
            options: {
              choices: {
                'Last 24 Hours': { type: 'standard', state: true, value: 'day', order: 0 },
                'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
                'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
                All: { type: 'standard', state: false, value: 'all', order: 3 },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: true,
                  order: 4,
                  error: false,
                },
              },
              class: 'timeframe-filter',
              query_string_parameter: 'timeframe',
            },
          },
          {
            name: 'Other',
            type: 'single_choice',
            options: {
              choices: {
                All: { type: 'standard', state: true, value: 'all', order: 0 },
                'Transactions with Unapplied Promotion Codes': {
                  type: 'standard',
                  state: false,
                  value: 'transactions_unapplied_codes',
                  order: 1,
                },
                'Incomplete/Errored Transactions': {
                  type: 'standard',
                  state: false,
                  value: 'transactions_errored',
                  order: 2,
                },
                'Incomplete/Errored Redemptions': {
                  type: 'standard',
                  state: false,
                  value: 'redemptions_errored',
                  order: 3,
                },
              },
              class: 'other-filter above-divider',
              query_string_parameter: 'other_filters',
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Activity Status',
            type: 'multiple_choice',
            options: {
              choices: {},
              choices_endpoint: '/2.0/user-activities/statuses/?paginate=false',
              choices_endpoint_data_key: 'user-activity-statuses',
              class: 'scroll-choices above-divider',
              name_attribute: 'name',
              no_selected_parameter: 'none',
              query_string_parameter: 'status',
              select_all: true,
            },
          },
        ],
        sort_options: {
          activity_date: {
            state: true,
            value: '-1',
            title: 'Activity Date',
            order: 0,
          },
          data_type: {
            state: false,
            value: '1',
            title: 'Activity Data Type',
            order: 1,
          },
          num_points: {
            state: false,
            value: '1',
            title: 'Activity Points',
            order: 2,
          },
        },
      };

      $scope.$on('$routeChangeStart', async (event, current) => {
        if (
          !current?.params?.redemptionId &&
          !current?.params?.transactionId &&
          !current?.params?.petId &&
          !current?.params?.activityId
        ) {
          $rootScope.userId = null;
        }
      });

      $scope.init();

      $scope.$on('$destroy', $scope.unsubscribe);
    },
  );
